<template>
    <div>
        <div class="caption font-weight-bold">
            {{ titulo(solucionConstructiva) }}
        </div>
        <div v-if="procesosConstructivos.length == 0 && !cargandoProcesosConstructivos" class="caption py-2">
            {{ $t('selec_reves') }}
        </div>

        <seleccion-componente-s-c v-model="seleccionado" :items="procesosConstructivos" nombre="name"
                                  propiedad="code" descripcion="description"
                                  :cargando="cargandoProcesosConstructivos"
                                  @change="cambiarProcesoConstructivo"/>
    </div>
</template>

<script>
    import {HttpHelper} from "../../../../../../comunes/helpers/HttpHelper";
    import DescripcionesServicio from "../../../../../../comunes/servicios/DescripcionesServicio";
    import SeleccionComponenteSC from "./SeleccionComponenteSC";

    export default {
        name: "ProcesoConstructivo",
        components: {
            SeleccionComponenteSC
        },
        model: {
            prop: 'correcto',
            event: 'change'
        },
        props: {
            tipo: {type: String, required: true},
            solucionConstructiva: {type: Object, required: true},
            proyectoId: {type: [Number, String], required: true},
            escenario: {type: Object, required: true},
            correcto: {type: Boolean, default: false}
        },
        data: () => ({
            cargandoProcesosConstructivos: false,
            procesosConstructivos: [],
            seleccionado: null
        }),
        mounted() {
            this.cargarProcesoConstructivo(this.escenario);
        },
        watch: {
            escenario: {
                handler(val) {
                    this.cargarProcesoConstructivo(val);
                },
                deep: true
            },
            solucionConstructiva: {
                handler(val) {
                    this.seleccionado = val.constructiveProcess;
                    this.emitirCorrecto(this.procesoConstructivoCorrecto(val));
                },
                deep: true
            },
        },
        methods: {
            titulo(solCons) {
                return DescripcionesServicio.materialSolCons(solCons);
            },
            cargarProcesoConstructivo(escenario) {
                this.procesosConstructivos = [];
                if (typeof escenario === "undefined") return;
                if (escenario.existingCoating == null) return;

                let params = {
                    'forceExistingCoating': escenario.existingCoating.code
                };

                let tipo = this.tipo;
                let solConsId = this.solucionConstructiva.id;

                let url = `rehabilitacion/${tipo}/solucion-constructiva/${solConsId}/proceso-constructivo`;
                this.cargandoProcesosConstructivos = false;
                HttpHelper.get(url, params).then(data => {
                    this.procesosConstructivos = data;

                    if (this.procesosConstructivos.length === 1) {
                        this.solucionConstructiva.constructiveProcess = this.procesosConstructivos[0];
                        return;
                    }

                    if (this.solucionConstructiva.constructiveProcess == null) return;

                    let found = false;
                    this.procesosConstructivos.forEach((procesoConstructivo) => {
                        if (procesoConstructivo.code === this.solucionConstructiva.constructiveProcess.code) {
                            found = true;
                            this.seleccionado = procesoConstructivo;
                            this.emitirCorrecto(this.procesoConstructivoCorrecto(this.solucionConstructiva));
                        }
                    });

                    if (!found) this.solucionConstructiva.constructiveProcess = null;
                }).finally(() => {
                    this.cargandoProcesosConstructivos = false;
                });
            },
            emitirCorrecto(value) {
                this.$emit('change', value);
            },
            cambiarProcesoConstructivo() {
                this.solucionConstructiva.constructiveProcess = this.seleccionado;
            },
            procesoConstructivoCorrecto(solucionConstructiva) {
                if (solucionConstructiva.constructiveProcess == null) return false;

                return solucionConstructiva.constructiveProcess != null;
            },
        }
    }
</script>

<style scoped>

</style>

<!--@formatter:off-->
<i18n>
    {
    "es": {
    "selec_reves": "Se debe seleccionar el revestimiento existente para poder añadir el proceso constructivo."
    }
    }
</i18n>
<!--@formatter:on-->